<div class="ui-g documents-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align form-title">{{'home.message.para_one' | translate}}</div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 document-section-container">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
      <h4 class="margin-header-align text-uppercase">{{'download-center.page-title' | translate}}</h4>
      <hr/>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
      <ng-container *ngIf="documents && documents.length">
        <div *ngFor="let document of documents; let i=index;">
          <div class="document-section">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 form-column">
              <div
                class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 margin-align document-background">
                <label
                  class="row-documents-label ui-g-12 ui-xl-5 ui-lg-5 ui-md-5 ui-sm-12 margin-align">{{document.name}}</label>
                <div class="file-name-view-box ui-g-12 ui-xl-7 ui-lg-5 ui-md-7 ui-sm-12">
                  <span class="file-name ui-g-9 text-center"></span>
                  <button
                    (click)="downloadFile(document['document_id'], document.filename)"
                    class="ui-g-3 view-btn"
                    id="docs-download-btn-{{i}}"
                    label="{{'view-button-label' | translate}}"
                    pButton
                    type="button"></button>
                </div>
                <div class="text-center">-</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
